/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

async function action({ fetch, store }, routeParams) {
  const query = `{
      configuration {
        findByScope (scope: "/redirect/${routeParams.scope}") {
          ... on Generalconfig { scope data { value } }
        }
      }
    }`;

  const scopeResponse = await fetch(`/${routeParams.siteId}/graphql`, {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
    credentials: 'include',
  }).then(resp => (resp.status !== 200 ? null : resp.json()));

  console.info('redirect', scopeResponse);

  if (scopeResponse == null) {
    return null;
  }

  return (
    (((scopeResponse.data || {}).configuration || {}).findByScope || {}).data ||
    {}
  ).value
    ? { redirect: scopeResponse.data.configuration.findByScope.data.value }
    : null;
}

export default action;



// WEBPACK FOOTER //
// ./src/routes/client/site/redirect/index.js